import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class RenterPolicyResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("RenterPolicyResourcePackage");
    }
    public get assets_views_renter_policy_images_images_0_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/renter_policy/images/images-0_1x.atlas.json");
    }
    public get assets_views_renter_policy_images_frame_mid_png(): Texture {
        return this.assets_views_renter_policy_images_images_0_1x_atlas_json.textures["frame_mid.png"];
    }
    public get assets_views_renter_policy_images_frame_long_png(): Texture {
        return this.assets_views_renter_policy_images_images_0_1x_atlas_json.textures["frame_long.png"];
    }
    public get assets_views_renter_policy_images_scrollbar_line_png(): Texture {
        return this.assets_views_renter_policy_images_images_0_1x_atlas_json.textures["scrollbar/line.png"];
    }
    public get assets_views_renter_policy_images_frame_light_png(): Texture {
        return this.assets_views_renter_policy_images_images_0_1x_atlas_json.textures["frame_light.png"];
    }
    public get assets_views_renter_policy_images_scrollbar_lift_png(): Texture {
        return this.assets_views_renter_policy_images_images_0_1x_atlas_json.textures["scrollbar/lift.png"];
    }
    public get assets_views_renter_policy_images_images_0_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/renter_policy/images/images-0_1x.atlas.png");
    }
    public get assets_views_renter_policy_images_images_1_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/renter_policy/images/images-1_1x.atlas.json");
    }
    public get assets_views_renter_policy_images_frame_short_png(): Texture {
        return this.assets_views_renter_policy_images_images_1_1x_atlas_json.textures["frame_short.png"];
    }
    public get assets_views_renter_policy_images_images_1_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/renter_policy/images/images-1_1x.atlas.png");
    }
    public get assets_views_renter_policy_renter_text_renter_policy_notification_txt(): string {
        return this.resource<string>("assets/views/renter_policy/renter_text/renter_policy_notification.txt");
    }
    public get assets_views_renter_policy_renter_text_renter_policy_notification_deleted_txt(): string {
        return this.resource<string>("assets/views/renter_policy/renter_text/renter_policy_notification_deleted.txt");
    }
    public get assets_views_renter_policy_renter_text_renter_policy_text_txt(): string {
        return this.resource<string>("assets/views/renter_policy/renter_text/renter_policy_text.txt");
    }
}

